<header class="app-header" [ngClass]="{'header-hide': isHeaderHidden, 'header-show': !isHeaderHidden}">
  <div class="navbar-container">
    <!-- Logo/Title area -->
    <div class="navbar-brand">
      <span>TKD Exámenes</span>
    </div>
    
    <!-- Mobile toggle button -->
    <button class="navbar-toggle" (click)="toggleNavbar()" aria-label="Toggle navigation">
      <i class="fas fa-bars"></i>
    </button>
    
    <!-- Navigation menu with dropdown groups -->
    <nav class="navbar" [class.navbar-open]="isNavOpen">
      <ul class="nav-list">
        <!-- Group 1: Estudiantes y exámenes -->
        <li class="nav-item dropdown">
          <a href="javascript:void(0)" class="dropdown-toggle" (click)="toggleDropdown('estudiantes')">
            Estudiantes y exámenes <i class="fas fa-chevron-down"></i>
          </a>
          <ul class="dropdown-menu" [class.show]="activeDropdown === 'estudiantes'">
            <li class="dropdown-item">
              <a routerLink="/buscar-estudiante" routerLinkActive="active" (click)="closeNavbar()">
                <i class="fas fa-id-card"></i> Buscar por Nro libreta
              </a>
            </li>
            <li class="dropdown-item">
              <a routerLink="/estudiantes" routerLinkActive="active" (click)="closeNavbar()">
                <i class="fas fa-search"></i> Buscar por filtros
              </a>
            </li>
            <li class="dropdown-item">
              <a routerLink="/control-examen" routerLinkActive="active" (click)="closeNavbar()">
                <i class="fas fa-calendar-check"></i> Control de Examen
              </a>
            </li>
          </ul>
        </li>
        
        <!-- Group 2: Escuela -->
        <li class="nav-item dropdown">
          <a href="javascript:void(0)" class="dropdown-toggle" (click)="toggleDropdown('escuela')">
            Escuela <i class="fas fa-chevron-down"></i>
          </a>
          <ul class="dropdown-menu" [class.show]="activeDropdown === 'escuela'">
            <li class="dropdown-item">
              <a routerLink="/instructores" routerLinkActive="active" (click)="closeNavbar()">
                <i class="fas fa-user-tie"></i> Instructores
              </a>
            </li>
            <li class="dropdown-item">
              <a routerLink="/centros-entrenamiento" routerLinkActive="active" (click)="closeNavbar()">
                <i class="fas fa-map-marker-alt"></i> Centros de entrenamiento
              </a>
            </li>
          </ul>
        </li>
        
        <!-- Group 3: Otros -->
        <li class="nav-item dropdown">
          <a href="javascript:void(0)" class="dropdown-toggle" (click)="toggleDropdown('otros')">
            Otros <i class="fas fa-chevron-down"></i>
          </a>
          <ul class="dropdown-menu" [class.show]="activeDropdown === 'otros'">
            <li class="dropdown-item">
              <a [href]="tablaUrl" target="_blank" (click)="closeNavbar()">
                <i class="fas fa-table"></i> Tabla de Estudiantes (Deshabilitado)
              </a>
            </li>
            <li class="dropdown-item">
              <a routerLink="/itf-database" routerLinkActive="active" (click)="closeNavbar()">
                <i class="fas fa-globe"></i> ITF Database
              </a>
            </li>
            <li class="dropdown-item">
              <a href="javascript:void(0)" (click)="openCalculadoraPromedios(); closeNavbar();">
                <i class="fas fa-calculator"></i> Calculadora de Promedios
              </a>
            </li>
            <li class="dropdown-item" *ngIf="isAdmin">
              <a routerLink="/usuarios" (click)="closeNavbar()">
                <i class="fas fa-users-cog"></i> Gestionar Usuarios
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>

    <!-- User menu (right side) -->
    <div class="user-menu" *ngIf="currentUser">
      <button class="user-menu-toggle" (click)="toggleDropdown('user')" aria-label="User menu">
        <i class="fas fa-user-circle"></i>
        <span class="username">{{ currentUser.username }}</span>
        <i class="fas fa-chevron-down"></i>
      </button>
      <ul class="dropdown-menu user-dropdown" [class.show]="activeDropdown === 'user'">
        <li class="dropdown-header">
          <div class="user-info">
            <strong>{{ currentUser.username }}</strong>
            <small>{{ getRoleDisplay(currentUser.role) }}</small>
          </div>
        </li>
        <li class="dropdown-divider"></li>
        <li class="dropdown-item">
          <a routerLink="/mi-perfil" (click)="closeNavbar()">
            <i class="fas fa-user"></i> Mi usuario
          </a>
        </li>
        <li class="dropdown-item">
          <a routerLink="/cambiar-password" (click)="closeNavbar()">
            <i class="fas fa-key"></i> Cambiar contraseña
          </a>
        </li>
        <li class="dropdown-divider"></li>
        <li class="dropdown-item">
          <a href="javascript:void(0)" (click)="logout()" class="logout-link">
            <i class="fas fa-sign-out-alt"></i> Salir
          </a>
        </li>
      </ul>
    </div>
  </div>
</header>

<div class="app-content">
  <router-outlet></router-outlet>
</div>

<footer class="app-footer" *ngIf="!isProduction || currentUser">
  <div class="footer-container">
    <!-- Environment Badge -->
    <div class="footer-left">
      <span class="environment-badge" 
            [class.env-development]="environment === 'development'" 
            [class.env-test]="environment === 'test'"
            [class.env-production]="environment === 'production'">
        <i class="fas fa-server"></i>
        Entorno: {{ environment === 'development' ? 'Desarrollo' : environment === 'test' ? 'Test' : 'Productivo' }}
      </span>
    </div>

    <!-- Center Info -->
    <div class="footer-center">
      <span class="app-version">
        <i class="fas fa-code-branch"></i>
        v{{ appVersion }}
      </span>
      <span class="separator">•</span>
      <span class="copyright">
        © {{ currentYear }} Hakkyo
      </span>
    </div>

    <!-- Right Info (User info or link) -->
    <div class="footer-right">
      <span *ngIf="currentUser" class="user-info-footer">
        <i class="fas fa-user"></i>
        {{ currentUser.username }}
        <span class="user-role-badge">{{ getRoleDisplay(currentUser.role) }}</span>
      </span>
      <a *ngIf="!currentUser" href="javascript:void(0)" class="footer-link">
        <i class="fas fa-question-circle"></i>
        Ayuda
      </a>
    </div>
  </div>
</footer>